import { render } from "./AddPlace.vue?vue&type=template&id=3d7ee31f&scoped=true&ts=true"
import script from "./AddPlace.vue?vue&type=script&lang=ts"
export * from "./AddPlace.vue?vue&type=script&lang=ts"

import "./AddPlace.vue?vue&type=style&index=0&id=3d7ee31f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7ee31f"]])

export default __exports__